import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twitter',
  templateUrl: './twitter.component.html',
  styleUrls: ['./twitter.component.less']
})
export class TwitterComponent implements OnInit {
  hashtags = [
    'Tweets',
    'Chemistry',
    'Biology',
    'Science'];
  view = this.hashtags[0];
  constructor() { }

  ngOnInit(): void {
  }

  getView(view) {
    this.view = view;
  }

}
